const state = {
    workspace_selected: null,
}

const getters = {
    getWorkspaceId: (state) => state.workspace_selected,
}

const actions = {
    async changeWorkspace({commit, state}, workspace_id){
        commit("updateWorkspace", workspace_id)
    },
}

const mutations = {
    updateWorkspace: (state, workspace_id) => {
        state.workspace_selected = workspace_id
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}